import apiClient from '../../../../api/client';
import type {
  CorteMoraExportFormat,
  CorteMoraFilters,
  CorteMoraResponse,
  CorteMoraStatsResponse,
  QueryCorteMora,
} from '@aid/shared';

export type {
  CorteMoraClienteRow,
  CorteMoraExportFormat,
  CorteMoraFilters,
  CorteMoraResponse,
  CorteMoraStatsResponse,
  QueryCorteMora,
} from '@aid/shared';

const REPORT_PATH = '/admin/reportes/clientes-con-facturas-pendientes';

export async function getCorteMora(params: QueryCorteMora): Promise<CorteMoraResponse> {
  const { data } = await apiClient.get<CorteMoraResponse>(REPORT_PATH, { params });
  return data;
}

export async function getCorteMoraStats(params: CorteMoraFilters): Promise<CorteMoraStatsResponse> {
  const { data } = await apiClient.get<CorteMoraStatsResponse>(`${REPORT_PATH}/stats`, { params });
  return data;
}

export async function exportCorteMora(
  format: CorteMoraExportFormat,
  filters: CorteMoraFilters,
): Promise<Blob> {
  const { data } = await apiClient.get<Blob>(`${REPORT_PATH}/export`, {
    params: { ...filters, format },
    responseType: 'blob',
  });
  return data;
}
